/**
 * Created by Alex Aguilar on 4/5/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('aircraftCtrl', aircraftCtrl)
        .controller('newAircraftCtrl', newAircraftCtrl)
        .controller('editAircraftCtrl', editAircraftCtrl)
        .controller('deleteAircraftCtrl', deleteAircraftCtrl);

    aircraftCtrl.$inject = ['linkService', 'tabs', 'aircrafts'];
    newAircraftCtrl.$inject = ['modelAircraftService','aircraftService','tabs','modelAircrafts','fuelTypes'];
    editAircraftCtrl.$inject = ['$stateParams','modelAircraftService', 'aircraftService','tabs','modelAircrafts','fuelTypes','aircraft'];
    deleteAircraftCtrl.$inject = ['$stateParams', '$uibModalInstance','aircraftService','aircraft'];

    function aircraftCtrl(linkService,tabs,aircrafts){
        var vm = this;
        vm.tabs = tabs;
        vm.pages = [];
        vm.linkService = linkService;
        vm.aircrafts = (aircrafts.data._embedded) ? aircrafts.data._embedded.aircrafts : [];
        vm.pages = aircrafts.data.page;
    }

    function newAircraftCtrl(modelAircraftService,aircraftService,tabs,modelAircrafts,fuelTypes){
        var vm = this;
        vm.tabs = tabs;
        vm.modelAircrafts = modelAircrafts.data._embedded ? modelAircrafts.data._embedded.modelAircrafts : [];
        vm.structures = [];
        vm.fuelTypes = (fuelTypes.data._embedded) ? fuelTypes.data._embedded.fuelTypes : [];
        vm.aircraft = {};
        vm.cargoPassengerCheck = {};
        vm.requiredCheck = true;
        vm.cont = 0;
        vm.buttonSave = false;

        vm.saveAircraft = function(isValid, aircraft, cargoPassenger){
            if (isValid) {
                var saveAircraft = {
                    'plaque': aircraft.plaque,
                    'cargo': cargoPassenger[1],
                    'passenger': cargoPassenger[2],
                    'structureId': aircraft.structureId,
                    'fuelTypeId': aircraft.fuelTypeId
                };
                aircraftService.saveAircraft(saveAircraft);
            }
        }

        vm.getStructureByModelAircraft = function(modelAircraft){
            if(modelAircraft != undefined) {
                modelAircraftService.getModelAircraftStructures(modelAircraft.makerId, modelAircraft.modelAircraftId)
                    .then(function (res) {
                        vm.structures = (res.data._embedded) ? res.data._embedded.structures : [];
                    })
            }else{
                vm.structures = [];
            }
        }

        vm.change = function(){
            vm.requiredCheck = !(vm.cargoPassengerCheck[1] || vm.cargoPassengerCheck[2]);
            vm.cont++;
        }
    }

    function editAircraftCtrl($stateParams,modelAircraftService,aircraftService,tabs,modelAircrafts,fuelTypes,aircraft){
        var vm = this;
        vm.tabs = tabs;
        vm.aircraft = {};
        vm.modelAircrafts = modelAircrafts.data._embedded.modelAircrafts;
        vm.modelAircraft = {};
        vm.structures = [];
        vm.fuelTypes = (fuelTypes.data._embedded) ? fuelTypes.data._embedded.fuelTypes : [];
        vm.requiredCheck = false;
        vm.cont = 1;

        function getAircraft(aircraft){
            var dataModelAircraft = aircraft.data;
            vm.aircraft = {
                'fuelTypeId': dataModelAircraft._embedded.fuelType.fuelTypeId,
                'plaque': dataModelAircraft.plaque,
                'structureId': dataModelAircraft._embedded.structure.structureId
            }
            vm.modelAircraft = dataModelAircraft._embedded.structure._embedded.modelAircraft;
            vm.getStructureByModelAircraft(vm.modelAircraft);
            vm.cargoPassenger = {'cargo': dataModelAircraft.cargo, 'passenger': dataModelAircraft.passenger};
            vm.cargoPassengerCheck = {1: dataModelAircraft.cargo, 2: dataModelAircraft.passenger};
            vm.old = angular.copy(vm.aircraft);
            vm.oldModelAircraft = angular.copy(vm.modelAircraft);
            vm.oldBox = angular.copy(vm.cargoPassengerCheck);
            vm.buttonSave = true;
        }

        vm.saveAircraft = function(isValid, aircraft, cargoPassenger){
            if (isValid) {
                var updateAircraft = {
                    'plaque': aircraft.plaque,
                    'cargo': cargoPassenger[1],
                    'passenger': cargoPassenger[2],
                    'structureId': aircraft.structureId,
                    'fuelTypeId': aircraft.fuelTypeId
                };

                aircraftService.updateAircraft(updateAircraft, $stateParams.id);
            }
        }

        vm.getStructureByModelAircraft = function(modelAircraft){
            if(modelAircraft != undefined) {
                modelAircraftService.getModelAircraftStructures(modelAircraft.makerId, modelAircraft.modelAircraftId)
                    .then(function (res) {
                        vm.structures = (res.data._embedded) ? res.data._embedded.structures : [];
                    })
            }else{
                vm.structures = [];
            }
        }

        getAircraft(aircraft);

        vm.change = function(){
            if(vm.modelAircraft!=undefined&&vm.modelAircraft.name==vm.oldModelAircraft.name&&
                vm.aircraft.plaque.toUpperCase()==vm.old.plaque.toUpperCase() &&
                vm.aircraft.structureId==vm.old.structureId &&
                vm.aircraft.fuelTypeId==vm.old.fuelTypeId &&
                vm.cargoPassengerCheck[1] == vm.oldBox[1] && vm.cargoPassengerCheck[2] == vm.oldBox[2] ){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }

            vm.requiredCheck = !(vm.cargoPassengerCheck[1] || vm.cargoPassengerCheck[2]);
        }
    }

    function deleteAircraftCtrl($stateParams,$uibModalInstance,aircraftService,aircraft){
        var vm = this;
        vm.aircraft = aircraft.data;

        vm.confirmDeleteAircraft = function(){
            aircraftService.deleteAircraft($stateParams.id)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
